import { useToggle } from '@shopify/react-hooks';
import { useUniqueId } from '../../../utilities/unique-id/hooks.mjs';

function usePopover({
  open: initialValue = false,
  ariaHasPopup
}) {
  const {
    value: isOpen,
    setTrue: open,
    setFalse: close,
    toggle
  } = useToggle(initialValue);
  const id = useUniqueId('Popover');
  const activatorAccessibilityProps = {
    'aria-controls': id,
    'aria-expanded': isOpen,
    'aria-haspopup': ariaHasPopup
  };
  const popoverAccessibilityProps = {
    role: getRole(ariaHasPopup),
    id
  };
  return {
    activatorAccessibilityProps,
    popoverAccessibilityProps,
    isOpen,
    open,
    close,
    toggle
  };
}
function getRole(ariaHasPopup) {
  switch (ariaHasPopup) {
    case 'menu':
    case 'listbox':
    case 'tree':
    case 'grid':
    case 'dialog':
      return ariaHasPopup;
    case 'true':
    case true:
      // "true" is treated the same as "menu"
      // See: https://w3c.github.io/aria/#aria-haspopup
      return 'menu';
    case 'false':
    case false:
    case undefined:
    default:
      return undefined;
  }
}

export { usePopover };
